"use client";

var __jsx = React.createElement;
import React, { useEffect } from "react";
import { useModalMessages } from "@lib/context/shared/modal-message-context";
import { useActiveContent } from "@lib/context/shared/active-content-context";
import MuscleMessageModal from "@modules/shared/components/message-modal";
import MuscleNotification from "@modules/shared/components/notification";
import MuscleLoadingScreen from "@modules/shared/components/muscle-loading-screen";
import APP_CONFIGURATION from "@lib/app.config";
import { cn } from "@lib/cn";
import { useCustomer } from "@lib/context/shared/customer-context";
import { PageContainer } from "@modules/layout/components/shared/container";
import MusclePlatformLayout from "@modules/layout";
import useMuscleRouter from "@lib/hooks/use-muscle-router";
import { BREAKPOINTS, DEFAULT_APP } from "@lib/constants";
import { useIsLoadingResources } from "@lib/context/shared/loading-resources-context";
import { usePathname } from "next/navigation";
import PromotionsModal from "@modules/home/components/promotions-modal";
import { useMediaQuery } from "react-responsive";
import FocusTrap from "@mui/material/Unstable_TrapFocus";
import { PaymentSessionProvider } from "@lib/context/shared/payment-session-context";
import LocaleHandler from "components/LocaleHandler";
const applicationFlows = ["hotels", "flights", "cars", "millasbenefit", "brand"];
const Main = _ref => {
  var _process$env$NEXT_PUB;
  let {
    locale,
    children
  } = _ref;
  const isMobile = useMediaQuery({
    query: "(max-width: ".concat(BREAKPOINTS.md, "px)")
  });
  const [showPromotionsModal, setShowPromotionsModal] = React.useState(false);
  const {
    modalIsOpen,
    setModalIsOpen,
    modalProps
  } = useModalMessages();
  const {
    activeContent,
    isOverlay
  } = useActiveContent();
  const {
    allowUnauthenticatedCustomer,
    customerIsLogged,
    isLoadingCustomer
  } = useCustomer();
  const mainBaseStyle = 'global-font global-main-app relative flex flex-col overflow-y-scroll h-screen app_background_color';
  const router = useMuscleRouter();
  const defaultApp = (_process$env$NEXT_PUB = process.env.NEXT_PUBLIC_DEFAULT_APP) !== null && _process$env$NEXT_PUB !== void 0 ? _process$env$NEXT_PUB : DEFAULT_APP;
  const actualApp = defaultApp;
  const maintainanceActive = process.env.NEXT_PUBLIC_SHOW_LANDING_MAINTENANCE === "true";
  const {
    setIsLoadingPage
  } = useIsLoadingResources();
  const pathname = usePathname();
  const goHome = (actualApp, origin) => {
    // ACTIVE HOTEL DETAIL
    if (locale && !router.isLanding()) {
      return;
    }

    // IMPORTANT: Don't add locale prefix manually - next-intl router handles it automatically
    if (actualApp) {
      router.replace("/".concat(actualApp));
    } else {
      router.replace("/");
    }
  };
  const setCurrentApp = () => {
    if (isLoadingCustomer) return;
    if (maintainanceActive) {
      router.replace("/");
      return;
    }
    if (customerIsLogged || allowUnauthenticatedCustomer) {
      if ((pathname === "/" || pathname === "/".concat(locale)) && APP_CONFIGURATION.config.appName === "Benefit Viajes") {
        goHome(actualApp, "home");
        return;
      }
      const pathParts = (pathname !== null && pathname !== void 0 ? pathname : "/").split("/");
      const currentApp = pathParts.find(part => applicationFlows.includes(part));
      const isOnApplicationFlow = (pathParts === null || pathParts === void 0 ? void 0 : pathParts.length) > 2 && applicationFlows.includes(currentApp !== null && currentApp !== void 0 ? currentApp : "");
      if (isOnApplicationFlow) {
        return;
      }
      goHome(actualApp);
    } else if (!customerIsLogged && !allowUnauthenticatedCustomer) {
      /* TODO PASSWORD EDIT
      const noReplaceFor = "/password/edit"
      if (locale || pathname.includes(noReplaceFor)) return
      goHome()
      */
      router.replace("/");
    }
  };
  useEffect(() => {
    if (maintainanceActive) {
      router.replace("/");
    } else {
      setCurrentApp();
    }
  }, [maintainanceActive, isLoadingCustomer]);
  useEffect(() => {
    const expiredState = localStorage.getItem("expiration-state");
    const openParam = router.getQueryParam("open") && APP_CONFIGURATION.config.permit_open_profile_tab_in_login;
    if ((!expiredState || expiredState && expiredState !== "expired") && !openParam) {
      setCurrentApp();
    }
  }, [customerIsLogged]);
  useEffect(() => {
    if (customerIsLogged && !locale && isMobile) {
      setShowPromotionsModal(true);
    }
  }, [customerIsLogged, isMobile]);
  useEffect(() => {
    setIsLoadingPage(isLoadingCustomer);
  }, [isLoadingCustomer, setIsLoadingPage]);
  return __jsx(React.Fragment, null, __jsx(LocaleHandler, {
    locale: locale
  }), __jsx(PaymentSessionProvider, null, __jsx(MuscleLoadingScreen, null), __jsx(MuscleMessageModal, {
    isOpen: modalIsOpen,
    setIsOpen: setModalIsOpen,
    props: modalProps
  }), __jsx(MuscleNotification, null), showPromotionsModal && __jsx("div", {
    className: "md:hidden"
  }, __jsx(PromotionsModal, null)), __jsx("div", {
    id: "app",
    className: mainBaseStyle
  }, __jsx("div", {
    className: cn({
      hidden: isLoadingCustomer
    })
  }, __jsx("div", {
    className: cn("", {
      hidden: !isOverlay && activeContent
    })
  }, children), isOverlay && activeContent ? __jsx(React.Fragment, null, __jsx(FocusTrap, {
    open: true
  }, __jsx("div", {
    className: "fixed inset-0 bg-black bg-opacity-50 z-50"
  }, activeContent))) : activeContent), __jsx("div", {
    className: cn({
      hidden: !isLoadingCustomer
    })
  }, __jsx(MusclePlatformLayout, {
    headerProps: {
      hideContent: true
    },
    showCustomerSupport: false
  }, __jsx(PageContainer, {
    className: "h-screen"
  }))))));
};
export default Main;